import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './How.module.scss';

export const HowStepThree = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.howLeftSection}>
        <span className={styles.howStepLeft_1}>How</span>
        <span className={styles.howStepLeft_2}>does</span>
        <span className={styles.howStepLeft_3}>it work?</span>
      </div>
    }
    rightContent={
      <div className={styles.howStepContentWrapper}>
        <ul>
          <li style={{ marginBottom: 20 }}>
            ESG professional investors gain access to a list of companies with calculated ESG
            scores, expert assessments of companies, and can sign documents directly on the platform
            using blockchain-based notarization.
          </li>
          <li>
            TransparenTerra consumers can buy products and services that are truly sustainable and
            have a transparent origin, read blogs, and participate in webinars and join professional
            groups.
          </li>
        </ul>
      </div>
    }
  />
);
